import { parseFileProxySource } from '@Core/lib/tasks/utils/file';
import { useFileMetadata } from '@Pages/pageRuntime/context/FileMetadataContext';
import {
  useFileImageDelivery,
  type FileImageOptions,
  type NativeImageProps
} from '@Pages/pageRuntime/hooks/useFileImageDelivery';
import { PageImageRuntimeContext } from '@Pages/pageRuntime/imageRuntime';
import { useContext } from 'react';

const EMPTY_HOSTS: ReadonlySet<string> = new Set();

/**
 * The page adapter behind `FileImage` and `Sdk.Components.Image`. It recognizes
 * a workspace file source from the page's trusted hosts, reads the page's
 * authorized metadata, and applies the page's priority and print loading.
 */
export function useFileImage(
  props: NativeImageProps,
  options: FileImageOptions = {}
): NativeImageProps {
  const runtime = useContext(PageImageRuntimeContext);
  const { src, srcSet } = props;
  const source =
    typeof src === 'string' && srcSet === undefined && typeof window !== 'undefined'
      ? parseFileProxySource(src, runtime?.fileHosts ?? EMPTY_HOSTS, window.location.origin)
      : null;
  const metadata = useFileMetadata(source?.fileId);

  return useFileImageDelivery(props, {
    ...options,
    source,
    metadata,
    priority: runtime?.priority ?? null,
    eagerLoading: runtime?.eagerLoading ?? false
  });
}
